import React  from "react"

interface Props {
  isVisible?: boolean
}

const CaseAssetLabel: React.FC<Props> = ({isVisible = true, children}): JSX.Element => {
  if (!isVisible) return null

  return (<div className="font-bold text-ch-blue-600 uppercase"> {children} </div>)
}

export default CaseAssetLabel
